// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";
import { conditionClauseDtoList } from "./condition-clause-dto";

export class ConditionDto extends ItiBaseDto {
	public lang: string;
	public name: string;
	public description: string;
	public text: string;
	public conditionClauseList: conditionClauseDtoList[];
	public accepted: boolean;

	constructor(src?: any) {
		super(src);

		this.accepted = false;

		Object.assign(this, src);

		if (src) {
			this.conditionClauseList = src.conditionClauseList.map(
				(x: conditionClauseDtoList) => new conditionClauseDtoList(x),
			);
		}
	}
}
